export const LOGIN_SUCCESS = "login-success";
export const LOGOUT_REQUEST = "logout-request";
export const SET_SECTION = "SET_SECTION";
export const UPDATE_USER = "UPDATE_USER";
export const SET_HOME_SECTION = "SET_HOME_SECTION";
